import React from "react";

export default function DashboardIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 27 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round">
        <g
          id="Sidemenu-/-Item-Unselected"
          transform="translate(-19.000000, -6.000000)"
          stroke="#FFFFFF"
          strokeWidth="1.5">
          <g id="Icons-/-Line-/-Dashboard" transform="translate(20.000000, 7.435484)">
            <path
              d="M23.333,10.117 L23.333,23.333 C23.3308034,24.2523572 22.5863557,24.9972517 21.667,25 L3.333,25 C2.41364428,24.9972517 1.66919663,24.2523572 1.667,23.333 L1.667,10.117"
              id="Path"></path>
            <polyline id="Path" points="25 11.667 12.5 0 0 11.667"></polyline>
            <path
              d="M8.533,15 L16.466,15 C16.5764569,15 16.666,15.0895431 16.666,15.2 L16.666,25 L8.333,25 L8.333,15.2 C8.333,15.0895431 8.42254305,15 8.533,15 Z"
              id="Path"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
